<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">{{$t('page_404.Title')}}</h1>
            <div class="flex items-center">
                <vs-button v-if="this.$route.redirectedFrom" size="large" @click="goToPrevious" class="mr-4">{{$t('page_404.Back_previous')}}</vs-button>
                <vs-button size="large" to="/home">{{$t('page_404.Back_home')}}</vs-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            goToPrevious () {
                this.$router.go(-1)
            }
        }
    }
</script>
